import { render, staticRenderFns } from "./CopyStakeStreamingScheduleView.vue?vue&type=template&id=55e1cc0c&scoped=true&lang=pug"
import script from "./CopyStakeStreamingScheduleView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamingScheduleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1cc0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
